import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import YuYue from '@/pages/YuYue'
import GXHTC from '@/pages/GXHTC'
import user from '@/pages/user'
import verifyingCode from '@/pages/verifyingCode'
import tdyy from '@/pages/tdyy'
import yycg from '@/pages/yycg'
import shoplist from '@/pages/shoplist'
import gudingtc from '@/pages/gudingtc'
import tcjx from '@/pages/tcjx'
import shopcart from '@/pages/shopcart'
import confimOrder from '@/pages/confimOrder'
import paySuccess from '@/pages/paySuccess'
import orderYuYue from '@/pages/orderYuYue'
import singleYuYue from '@/pages/singleYuYue'
import yuyueSuccess from '@/pages/yuyueSuccess'
import orderPay from '@/pages/orderPay'
import orderTJ from '@/pages/orderTJ'
import queueSearch from '@/pages/queueSearch'
import scanResult from '@/pages/scanResult'
import reportSearch from '@/pages/reportSearch'
import personInfo from '@/pages/personInfo'
import updatePersonInfo from '@/pages/updatePersonInfo'
import examPerson from '@/pages/examPerson'
import dxjc from '@/pages/dxjc'
import orderTuan from '@/pages/orderTuan'
import personSel from '@/pages/personSel'
import subjectRadio from '@/pages/subjectRadio'
import subject from '@/pages/subject'
import login from '@/pages/login'
import personAdd from '@/pages/personAdd'
import personModify from '@/pages/personModify'
import confirmYuYue from '@/pages/confirmYuYue'
import confirmCX from '@/pages/confirmCX'
import confirmTJ from '@/pages/confirmTJ'
import orderStart from '@/pages/orderStart'
import orderFinish from '@/pages/orderFinish'
import survey from '@/pages/survey'
import tjjx from '@/pages/tjjx'
import wait from '@/pages/wait'

Vue.use(Router)
export default new Router({
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    redirect: '/home',
    name: '首页',
    component: home
  },
  {
    path: '/home',
    name: '首页',
    component: home
  },
  {
    path: '/user/YuYue',
    name: '预约',
    component: YuYue
  },
  {
    path: '/user/GXHTC/:customerID',
    name: '个性化套餐',
    component: GXHTC
  },
  {
    path: '/user',
    name: '个人中心',
    component: user
  },
  {
    path: '/verifyingCode',
    name: '注册',
    component: verifyingCode
  },
  {
    path: '/shoplist',
    name: '我的订单',
    component: shoplist
  },
  {
    path: '/user/shopcart',
    name: '我的购物车',
    component: shopcart
  },
  {
    path: '/user/confimOrder/:orderID',
    name: '确认订单',
    component: confimOrder
  },
  {
    path: '/user/paySuccess',
    name: '付款成功',
    component: paySuccess
  },
  {
    path: '/user/orderYuYue',
    name: '待预约',
    component: orderYuYue
  },
  {
    path: '/user/singleYuYue/:orderID',
    name: '体检预约',
    component: singleYuYue
  },
  {
    path: '/user/yuyueSuccess',
    name: '预约成功',
    component: yuyueSuccess
  },
  {
    path: '/user/orderPay',
    name: '待付款',
    component: orderPay
  },
  {
    path: '/user/tdyy',
    name: '团队预约',
    component: tdyy
  },
  {
    path: '/user/yycg',
    name: 'yycg',
    component: yycg
  },
  {
    path: '/user/gudingtc',
    name: '固定套餐',
    component: gudingtc
  },
  {
    path: '/user/tcjx/:id',
    name: '套餐加项',
    component: tcjx
  },
  {
    path: '/user/orderTJ',
    name: '待体检',
    component: orderTJ
  },
  {
    path: '/user/queueSearch',
    name: '排队查询',
    component: queueSearch
  },
  {
    path: '/user/scanResult',
    name: '扫一扫结果',
    component: scanResult
  },
  {
    path: '/user/reportSearch',
    name: '报告查询',
    component: reportSearch
  },
  {
    path: '/user/personInfo',
    name: '个人信息',
    component: personInfo
  },
  {
    path: '/user/updatePersonInfo',
    name: '个人信息修改',
    component: updatePersonInfo
  },
  {
    path: '/user/examPerson',
    name: '体检人信息',
    component: examPerson
  },
  {
    path: '/user/dxjc',
    name: '单项检查',
    component: dxjc
  },
  {
    path: '/user/orderTuan',
    name: '团检订单',
    component: orderTuan
  },
  {
    path: '/user/personSel/:type',
    name: '选择人员',
    component: personSel
  },
  {
    path: '/user/subjectRadio',
    name: '单选问卷',
    component: subjectRadio
  },
  {
    path: '/user/subject',
    name: '问卷',
    component: subject
  }, {
    path: '/user/login',
    name: '登录',
    component: login
  }, {
    path: '/user/personAdd',
    name: '添加体检人',
    component: personAdd
  }, {
    path: '/user/personModify/:customerID',
    name: '修改体检人',
    component: personModify
  }, {
    path: '/user/confirmYuYue/:orderID',
    name: '预约订单',
    component: confirmYuYue
  }, {
    path: '/user/confirmTJ/:orderID',
    name: '体检订单',
    component: confirmTJ
  }, {
    path: '/user/orderStart',
    name: '体检中',
    component: orderStart
  }, {
    path: '/user/orderFinish',
    name: '已完成',
    component: orderFinish
  }, {
    path: '/user/survey/:customerID',
    name: '问卷',
    component: survey
  }, {
    path: '/user/tjjx/:orderID',
    name: '团检加项',
    component: tjjx
  }, {
    path: '/wait',
    name: '敬请期待',
    component: wait
  }, {
    path: '/user/confirmCX/:orderID',
    name: '预约订单',
    component: confirmCX
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js